<template>
  <p>   {{dataStr?(dataStr.length<5?dataStr:dataStr.substring(0,25)+ '...'): '无'}} &nbsp;&nbsp;&nbsp;&nbsp;
    <el-tooltip class="cursor item" v-if="dataStr" effect="dark" placement="bottom" :disabled="disabled" :content="dataStr">
      <a @click="disabled = !disabled">[{{buttonText}}]</a>
    </el-tooltip></p>

  <!-- /.navbar-static-side -->
</template>

<script>

export default {
  name: 'tooltip-common',
  data: function (){
    return {
    }
  },
  props: {
		dataStr: {
      type: String,
      default: function (){
        return null
      }
    },
		buttonText: {
      type: String,
      default: function (){
        return "更多"
      }
    },

	},
  mounted: function () {

  },
  methods: {

  }
}
</script>
